import React, { Component } from "react";
import classes from "./ResetPassword.css";
import axios from "../../../axios";

class ResetPassword extends Component {

  state = {
    token: null,
    newPassword: "",
    confirmPassword: "",
    loading: true,
    validating: true,
    valid: false,
    error: null,
    success: false,
    userEmail: "",
    userName: ""
  }

  componentDidMount() {
    // Extract token from URL query params
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      this.setState({
        validating: false,
        loading: false,
        valid: false,
        error: "No reset token provided."
      });
      return;
    }

    this.setState({ token });

    // Validate token
    axios.get(`/platforms/accounts/reset-password/validate?token=${token}`)
      .then(response => {
        if (response.data && response.data.valid) {
          this.setState({
            validating: false,
            loading: false,
            valid: true,
            userEmail: response.data.email || "",
            userName: response.data.name || ""
          });
        } else {
          this.setState({
            validating: false,
            loading: false,
            valid: false,
            error: response.data.message || "Invalid token."
          });
        }
      })
      .catch(err => {
        const message = err.response?.data?.message || "Failed to validate reset token.";
        this.setState({
          validating: false,
          loading: false,
          valid: false,
          error: message
        });
      });
  }

  inputChangeHandler = (event, field) => {
    this.setState({ [field]: event.target.value });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    const { newPassword, confirmPassword, token } = this.state;

    // Validation
    if (!newPassword || newPassword.length < 5) {
      this.setState({ error: "Password must be at least 5 characters long." });
      return;
    }

    if (newPassword !== confirmPassword) {
      this.setState({ error: "Passwords do not match." });
      return;
    }

    this.setState({ loading: true, error: null });

    // Submit password reset
    axios.post('/platforms/accounts/reset-password/confirm', {
      token: token,
      newPassword: newPassword
    })
      .then(response => {
        this.setState({
          loading: false,
          success: true,
          error: null
        });
      })
      .catch(err => {
        const message = err.response?.data?.message || "Failed to reset password.";
        this.setState({
          loading: false,
          error: message
        });
      });
  }

  render() {
    const { validating, valid, error, success, loading, newPassword, confirmPassword, userName } = this.state;

    // Show validating message
    if (validating) {
      return (
        <div className={classes.pageContainer}>
          <div className={classes.formContainer}>
            <h2>Validating...</h2>
            <p>Please wait while we verify your password reset link.</p>
          </div>
        </div>
      );
    }

    // Show success message
    if (success) {
      return (
        <div className={classes.pageContainer}>
          <div className={classes.formContainer}>
            <h2>Password Reset Successful</h2>
            <p>Your password has been successfully reset.</p>
            <div className={classes.actions}>
              <a href="/" className={classes.backButton}>Back to Login</a>
            </div>
          </div>
        </div>
      );
    }

    // Show error if token is invalid
    if (!valid) {
      return (
        <div className={classes.pageContainer}>
          <div className={classes.formContainer}>
            <h2>Invalid Reset Link</h2>
            <p className={classes.error}>{error || "This password reset link is invalid or has expired."}</p>
            <p>Please request a new password reset from your administrator.</p>
            <div className={classes.actions}>
              <a href="/" className={classes.backButton}>Back to Login</a>
            </div>
          </div>
        </div>
      );
    }

    // Show reset password form
    return (
      <div className={classes.pageContainer}>
        <div className={classes.formContainer}>
          <h2>Reset Your Password</h2>
          {userName && <p className={classes.greeting}>Hello, {userName}</p>}
          
          <form onSubmit={this.handleSubmit}>
            <div className={classes.inputGroup}>
              <label htmlFor="newPassword">New Password</label>
              <input
                id="newPassword"
                type="password"
                value={newPassword}
                onChange={(e) => this.inputChangeHandler(e, 'newPassword')}
                placeholder="Enter new password"
                disabled={loading}
                required
                minLength="5"
              />
            </div>

            <div className={classes.inputGroup}>
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                id="confirmPassword"
                type="password"
                value={confirmPassword}
                onChange={(e) => this.inputChangeHandler(e, 'confirmPassword')}
                placeholder="Confirm new password"
                disabled={loading}
                required
                minLength="5"
              />
            </div>

            <div className={classes.actions}>
              <button 
                type="submit" 
                className={classes.submitButton}
                disabled={loading}
              >
                {loading ? <span className={classes.spinner}></span> : "Reset Password"}
              </button>
            </div>
          </form>

          {error && (
            <div className={classes.errorContainer}>
              <p>{error}</p>
            </div>
          )}

          <div className={classes.backLink}>
            <a href="/">Back to Login</a>
          </div>
        </div>
      </div>
    );
  }
}

export default ResetPassword;
